import { getChatContextMessageLimit } from '@/config/api/env'

export function buildChatCompletionBody({ messages, mode, threadId, sourceIds }) {
  const payload = trimMessagesForApi(messages)
  return {
    messages: payload,
    ...(mode !== undefined ? { mode } : {}),
    ...(threadId ? { threadId } : {}),
    ...(sourceIds.length ? { sourceIds } : {}),
  }
}

function trimMessagesForApi(messages) {
  const limit = getChatContextMessageLimit()
  return messages.length <= limit ? messages : messages.slice(-limit)
}
